import { useGetIntegrationWebhooks } from 'api';

import { useOrganisationId } from 'hooks/context';

export const useWebhooks = () => {
  const organisationId = useOrganisationId<number>();
  const { data, isLoading, isError } =
    useGetIntegrationWebhooks(organisationId);

  return { webhooks: data?.data ?? [], isLoading, isError };
};
